        <p-dialog
            header="User Settings"
            [visible]="visible()"
            (visibleChange)="onVisibleChange($event)"
            [modal]="true"
            [draggable]="false"
            [resizable]="false"
            [closable]="true"
            [appendTo]="'body'"
            [style]="{ width: '520px' }"
            styleClass="user-settings-dialog"
        >

            <div class="settings-content">

                <!-- =================================================
                     Appearance
                     ================================================= -->

                <div class="settings-section">

                    <div class="settings-section-title">
                        Appearance
                    </div>


                    <!-- Dark / Light -->

                    <div class="settings-field">

                        <label>
                            Color Scheme
                        </label>

                        <div class="option-group">

                            <p-button
                                label="Light"
                                icon="pi pi-sun"
                                [severity]="
                                    isLightMode()
                                        ? 'primary'
                                        : 'secondary'
                                "
                                [outlined]="!isLightMode()"
                                (onClick)="setLightMode()"
                            />

                            <p-button
                                label="Dark"
                                icon="pi pi-moon"
                                [severity]="
                                    isDarkMode()
                                        ? 'primary'
                                        : 'secondary'
                                "
                                [outlined]="!isDarkMode()"
                                (onClick)="setDarkMode()"
                            />

                        </div>

                    </div>
                    <!-- Primary -->

                    <div class="settings-field">

                        <label>
                            Primary Color
                        </label>

                        <div class="color-options">

                            @for (
                                color of primaryColors;
                                track color
                            ) {

                                <button
                                    type="button"
                                    class="color-option"
                                    [class.selected]="primary === color"
                                    [style.background-color]="
                                        getPrimaryColor(color)
                                    "
                                    [title]="color"
                                    (click)="setPrimary(color)"
                                ></button>

                            }

                        </div>

                    </div>



                    <!-- Preset -->

                    <div class="settings-field">

                        <label>
                            Theme
                        </label>

                        <div class="theme-options">

                            @for (
                                theme of themes;
                                track theme.value
                            ) {

                                <button
                                    type="button"
                                    class="theme-option"
                                    [class.selected]="
                                        selectedTheme() ===
                                        theme.value
                                    "
                                    (click)="
                                        setTheme(theme.value)
                                    "
                                >

                                    <span
                                        class="theme-preview"
                                        [class]="
                                            theme.previewClass
                                        "
                                    ></span>

                                    <span>
                                        {{ theme.label }}
                                    </span>

                                </button>

                            }

                        </div>

                    </div>

                </div>


                <!-- =================================================
                     Defaults
                     ================================================= -->

                <div class="settings-section">

                    <div class="settings-section-title">
                        Defaults
                    </div>


                    <!-- Company -->

                    <div class="settings-field">

                        <label for="default-company">
                            Default Company
                        </label>

                        <p-select
                            inputId="default-company"
                            class="w-full"
                            [options]="companies()"
                            optionLabel="name"
                            optionValue="id"
                            [(ngModel)]="companyId"
                            placeholder="Select company"
                            [showClear]="true"
                            (onChange)="onCompanyChange()"
                        />

                    </div>


                    <!-- Market -->

                    <div class="settings-field">

                        <label for="default-market">
                            Default Market
                        </label>

                        <p-select
                            inputId="default-market"
                            class="w-full"
                            [options]="markets()"
                            optionLabel="name"
                            optionValue="id"
                            [(ngModel)]="marketId"
                            placeholder="Select market"
                            [showClear]="true"
                            [disabled]="companyId === null"
                            appendTo="body"
                            [scrollHeight]="'250px'"
                        />

                    </div>

                </div>


                <!-- =================================================
                     Account
                     ================================================= -->

                <div class="settings-section">

                    <div class="settings-section-title">
                        Account
                    </div>


                    <div class="password-row">

                        <div>

                            <div class="password-title">
                                Password
                            </div>

                            <div class="password-description">
                                Change your account password.
                            </div>

                        </div>


                        <p-button
                            type="button"
                            label="Change Password"
                            icon="pi pi-key"
                            severity="secondary"
                            (onClick)="openChangePassword()"
                        />

                    </div>

                </div>

            </div>


            <!-- =====================================================
                 Footer
                 ===================================================== -->

            <ng-template #footer>

                <p-button
                    type="button"
                    label="Cancel"
                    severity="secondary"
                    (onClick)="close()"
                />

                <p-button
                    type="button"
                    label="Save"
                    icon="pi pi-check"
                    (onClick)="save()"
                />

            </ng-template>

        </p-dialog>


        <!-- =========================================================
             Change Password
             ========================================================= -->

        <pb-change-password-dialog
            [visible]="changePasswordDialogVisible()"
            (visibleChange)="
                changePasswordDialogVisible.set($event)
            "
            (changeRequested)="
                changePasswordRequested.emit($event)
            "
        />